<template>
  <div class="info-callout" role="note">
    <FontAwesomeIcon :icon="icon" class="info-callout__icon" />
    <div class="info-callout__body">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

defineProps<{
  icon: string | string[];
}>();
</script>

<style scoped lang="scss">
.info-callout {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: var(--phoenix-gray-50);
  border: 1px solid var(--phoenix-border-color-translucent);
  border-radius: 8px;
  font-size: 12px;
  color: var(--phoenix-gray-600);
  line-height: 1.5;
}

.info-callout__icon {
  color: var(--phoenix-primary);
  margin-top: 2px;
  flex-shrink: 0;
}

.info-callout__body {
  min-width: 0;

  :deep(strong) {
    color: var(--phoenix-gray-1000);
  }
}
</style>
